import { Navigate } from "react-router";
import { useCurrentUser } from "@/features/login/hooks/useCurrentUser";

interface RoleGuardProps {
  allowedRoles: string[];
  children: React.ReactNode;
  redirectTo?: string;
}

/**
 * Verifica el rol del usuario antes de renderizar children.
 * Si el usuario no tiene un rol permitido, redirige sin renderizar contenido protegido.
 * Lee el rol desde Redux (currentUser) sin requests adicionales al backend.
 */
export function RoleGuard({ allowedRoles, children, redirectTo = "/login" }: RoleGuardProps) {
  const { user } = useCurrentUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const rolNombre = user.rol?.nombre;

  if (!rolNombre || !allowedRoles.includes(rolNombre)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
